import { UpdateQuoteInput } from '__generated__/GQL';
import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';

import {
  UpdateQuoteDocument,
  UpdateQuoteMutation,
} from './graphql/updateQuote.gql';

const useUpdateQuote = () => {
  const [mutation, hook] = useErrorHandledMutation<UpdateQuoteMutation>(
    UpdateQuoteDocument,
    {
      awaitRefetchQueries: true,
    },
  );

  const updateQuote = (input: UpdateQuoteInput) =>
    mutation({ variables: { input } });

  return [updateQuote, hook] as const;
};

export default useUpdateQuote;
